/**
 * @generated SignedSource<<3f190cd10d94f57085cb4be715624caa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SuggestedPerson_person$data = {
  readonly first_name: string;
  readonly image_key: string | null | undefined;
  readonly last_name: string;
  readonly " $fragmentType": "SuggestedPerson_person";
};
export type SuggestedPerson_person$key = {
  readonly " $data"?: SuggestedPerson_person$data;
  readonly " $fragmentSpreads": FragmentRefs<"SuggestedPerson_person">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SuggestedPerson_person",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "first_name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last_name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image_key",
      "storageKey": null
    }
  ],
  "type": "people",
  "abstractKey": null
};

(node as any).hash = "de5e815fae06ed3a83b973432f5e2db3";

export default node;
